import React, { useState, lazy, Suspense } from "react";
import { Button, Dialog } from "@mui/material";
import DeleteGroupConfirmDialog from "./group/DeleteGroupConfirmDialog";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { CreateVehicleGroupSkeleton } from "../common/DialogSkeleton";
const CreateVehicleGroup = lazy(() => import("./group/CreateVehicleGroup"));

const VehicleGroupDataTableRowActions = ({ data, listView = true }) => {
  const { row: { vehicleGroupId } = {} } = data || {};
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openStaticGroupCreateDialog, setOpenStaticGroupCreateDialog] =
    useState(false);
  const handleDelete = () => {
    setOpenDeleteDialog(data?.row);
  };
  const handleEdit = () => {
    setOpenStaticGroupCreateDialog(data?.row);
  };

  return (
    <div>
      <Check I={CAN.MANAGE} a={SUBJECTS.GROUP}>
        <Button size="small" onClick={() => handleEdit(vehicleGroupId)}>
          Edit
        </Button>
        <>
          {listView && <span>|</span>}
          <Button size="small" onClick={() => handleDelete()}>
            Delete
          </Button>
        </>

        {openDeleteDialog && (
          <DeleteGroupConfirmDialog
            id={openDeleteDialog?.vehicleGroupId}
            name={openDeleteDialog?.vehicleGroupName}
            type="vehicle group"
            toggleDialog={() => setOpenDeleteDialog(false)}
          />
        )}
        {openStaticGroupCreateDialog && (
          <Dialog
            open={openStaticGroupCreateDialog}
            maxWidth={'lg'}
            onClose={() =>
              setOpenStaticGroupCreateDialog(!openStaticGroupCreateDialog)}
            PaperProps={{
              sx: { maxWidth: "1200px", height: "calc(100vh - 30px)" },
            }}
          >
            <Suspense fallback={<CreateVehicleGroupSkeleton />}>
              <CreateVehicleGroup
                open={openStaticGroupCreateDialog}
                toggleDialog={() =>
                  setOpenStaticGroupCreateDialog(!openStaticGroupCreateDialog)}
              />
            </Suspense>
          </Dialog>
        )}
      </Check>
    </div>
  );
};

export default VehicleGroupDataTableRowActions;
